module.exports = __webpack_public_path__ + "static/media/23.dd858bde.jpg";